// @flow
import { defineMessages } from 'react-intl';

/* eslint-disable max-len */

export const resetPassword = defineMessages({
    RESET_PASSWORD_SUCCESS_HEADER: {
        id: 'auth.reset-password.success-header',
        defaultMessage: 'Change Password'
    },
    RESET_PASSWORD_SUCCESS_BODY: {
        id: 'auth.reset-password.success-body',
        defaultMessage: 'Password changed correctly'
    },
    RESET_PASSWORD_SUCCESS_BUTTON_TEXT: {
        id: 'auth.reset-password.success-button',
        defaultMessage: 'Login'
    },
    RESET_PASSWORD_ERROR_HEADER: {
        id: 'auth.reset-password.error-header',
        defaultMessage: 'Ooops, something went wrong!'
    },
    RESET_PASSWORD_ERROR_BUTTON_TEXT: {
        id: 'auth.reset-password.retry',
        defaultMessage: 'Retry'
    },
    RESET_PASSWORD_ERROR_BODY: {
        id: 'auth.reset-password.unexpected-error',
        defaultMessage: "We're sorry, something unexpected has happened. Please try again in a few minutes' time."
    }
});

export const forgotPassword = defineMessages({
    FORGOTTEN_PASSWORD_SUCCESS_HEADER: {
        id: 'auth.forgot-password.success-header',
        defaultMessage: 'Success: Password reset email sent'
    },
    FORGOTTEN_PASSWORD_SUCCESS_BODY: {
        id: 'auth.forgot-password.success-body',
        defaultMessage:
            'To reset your password, please click the link in the email we have sent to the address you provided. Sometimes it can go into the junk mail folder, so please check that folder too.'
    },
    FORGOTTEN_PASSWORD_ERROR_HEADER: {
        id: 'auth.forgot-password.error-header',
        defaultMessage: 'Ooops, something went wrong!'
    },
    FORGOTTEN_PASSWORD_ERROR_BODY: {
        id: 'auth.forgot-password.error-body',
        defaultMessage: "We're sorry, something unexpected has happened. Please try again in a few minutes' time."
    }
});



// WEBPACK FOOTER //
// ./src/core/constants/strings.js